<template>
  <div class="feedback-form-images">
    <div class="feedback-form-images-container">
      <TransitionGroup name="image-list">
        <div
          v-for="image in form.images"
          :key="image.name + image.size"
          class="feedback-form-image"
          :style="{
            backgroundImage: `url(${getImageUrl(image)})`
          }"
        >
          <div
            v-if="!disableActions"
            class="feedback-form-image__delete"
            @click="deleteImage(image)"
          ></div>
        </div>
      </TransitionGroup>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { FeedbackForm } from './types/feedbackForm';

  const props = defineProps<{
    form: FeedbackForm;
    disableActions?: boolean;
  }>();

  function getImageUrl(file: File): string {
    return URL.createObjectURL(file);
  }

  function deleteImage(image: File) {
    const index = props.form.images.findIndex(img => img === image);
    props.form.images.splice(index, 1);
  }
</script>

<style>
  .feedback-form-images {
    position: relative;
    bottom: 0;
    right: 0;
    left: 0;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    gap: 12px;
    width: 100%;
  }

  .feedback-form-images-container {
    display: flex;
    overflow-x: auto;
    gap: 12px;
    padding-bottom: 16px;
  }

  .feedback-form-image {
    width: 136px;
    height: 136px;
    background: #f5f5f5;
    border-radius: 26px;
    background-size: cover;
    background-position: center;
    border: 3px solid var(--g-color-orange);
    flex-shrink: 0;
    position: relative;

    &:first-child {
      margin-left: 12px;
    }

    &:last-child {
      margin-right: 12px;
    }

    &__delete {
      position: absolute;
      right: 8px;
      top: 8px;
      background-color: var(--g-color-orange);
      border-radius: 50%;
      width: 24px;
      height: 24px;
      display: flex;
      align-items: center;
      justify-content: center;
      opacity: 0;
      cursor: pointer;
      transition: opacity 0.15s ease;
      background-image: url('@/assets/images/icons/delete-icon.svg');
      background-size: 18px;
      background-position: center;
      background-repeat: no-repeat;

      &:hover {
        opacity: 0.7;
      }
    }

    &:hover &__delete:not(:hover) {
      opacity: 1;
    }
  }

  .image-list-enter-active,
  .image-list-leave-active {
    transition: all 0.3s ease;
  }

  .image-list-enter-from {
    opacity: 0;
    transform: translateX(30px);
  }

  .image-list-leave-to {
    opacity: 0;
    transform: scale(0.5);
  }

  .image-list-move {
    transition: transform 0.3s ease;
  }

  @media (--mobile) {
    .feedback-form-images-container {
      padding-bottom: 0;
    }
    .feedback-form-image {
      width: 80px;
      height: 80px;
    }
  }
</style>
